import React, { useEffect, useState} from 'react';
import { Col, Form, Row } from 'antd';
import { FormField, Label } from 'components';
import { updateFormField } from 'store/forms/actions';
import { formFields2_1, formFields2_2 } from './formFields';
import { useDispatch, useSelector } from 'react-redux';
import { get, omit, isNil, isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { getFullDate , isBeneficiary } from 'utils';
// import SorefsisChart from '../sorefsisChart';
// import Sorefsis from 'components/sorefsis';

const CompanyDetails = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned); 
  const activeTaskName = useSelector(state => state?.forms?.activeTaskName); 
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  applicationReturned ||
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.application_returned_to_supplier" ||
                  activeTaskName === "task.name.accepted";
  const [abiPerfectureOptions, setAbiPerfectureOptions] = useState([]);
  const [abiDistrictOptions, setAbiDistrictOptions] = useState([]);
  const [tkOptions, setTkOptions] = useState([]);
  const kadBranches = useSelector(state => state.forms.kadBranches);
  // const mainKAD = useSelector(state => state.forms.carrier.mainKAD);
  const [sameMasterUser, setSameMasterUser] = useState(false);
  
  const carrierUsers = useSelector(
    state => state.forms.carrier.carrierUsers
  ) || [
    {
      userLName: carrier?.companyName ? carrier?.companyName : '',
      userPhone: carrier?.invMob ? carrier?.invMob : '',
      userEmail: carrier?.invMail ? carrier?.invMail : '',
    },
  ];
  
  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  useEffect(() => {
    form.setFieldsValue({
      companyName: carrier.companyName,
      abiVat: carrier.abiVat,
      regDate: carrier.regDate,
      abiStreetFull: carrier.abiStreetFull,
      abiTk: carrier.abiTk,
      abiPerfecture: carrier.abiPerfecture,
      abiDistrict: carrier.abiDistrict,
      invMob: carrier.invMob,
      mainKAD: carrier.mainKAD,//carrier.mainKAD +' - ' + carrier.mainKADDescription,
      companySize: carrier.companySize,
      website: carrier.website,
      invMail: carrier.invMail,
    });
    
    //after refresh validators fire
    if((carrier.website)) form.validateFields(['website'])
    if((carrier.invMob)) form.validateFields(['invMob'])
    if((carrier.invMail)) form.validateFields(['invMail'])

  }, [form, carrier]);



  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };


  // ------------------------- Carrier Users Update ------------------------------ //
 //Initialize carrierUsers on mount if carrierUsers is empty
  useEffect(() => {
    if (!carrier?.carrierUsers || carrier?.carrierUsers.length === 0) {
      const masterUser = {
        userLName: carrier?.companyName || '',
        userPhone: carrier?.invMob || '',
        userEmail: carrier?.invMail || '',
        id:null,
      };

      dispatch(updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value: [masterUser]
      }));
    }
  }, [carrier?.invMob, carrier?.invMail]);

  useEffect(() => {
      //The master user must be in first index, where index 0 is disabled
      const masterUser = {
        userLName: carrier?.companyName || '',
        userPhone: carrier?.invMob || '',
        userEmail: carrier?.invMail || '',
      };

      if (!carrier?.carrierUsers || carrier?.carrierUsers.length !== 0) {
        console.log("bike sto if")

        let tempMasterUser = carrierUsers.find(
        (user) =>
          user.userLName === (masterUser.userLName ? masterUser.userLName : '')
        );


        let clonedArray = structuredClone(tempMasterUser);
        clonedArray = {
          ...tempMasterUser,
          userLName: carrier?.companyName || '',
          userPhone: carrier?.invMob || '',
          userEmail: carrier?.invMail || '',
        }

        const filteredUsers = carrierUsers.filter(
          (user) =>
          user.userLName !== (masterUser.userLName ? masterUser.userLName : '') &&
          user.userPhone !== (masterUser.userPhone ? masterUser.userPhone : '') &&
          user.userEmail !== (masterUser.userEmail ? masterUser.userEmail : '')
        );

        const finalUsers = [clonedArray, ...filteredUsers];

        if (!isEqual(carrierUsers, finalUsers)) {
       setSameMasterUser(true);
       dispatch(
        updateFormField({
          group: 'carrier',
          key: 'carrierUsers',
          value: finalUsers
        })
        );
      } 
      } 
  }, [carrierUsers, carrier?.invMail, carrier?.invMob, carrier?.companyName]);


  return (
    <div className="">
      <Form
        form={form}
        initialValues={{
          ...carrier,
        }}
        trigger="onChange"
      >
        <div className="carrier-data-form">
          <p className="mt-2 mr-0 color-blue-3 text-bold font-size-24">
            Στοιχεία Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_1.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                {<Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled || viewMode}
                      {...omit(field, ['span', 'rules', 'offset'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                }
                </Col>
              );
            })}
          </Row>
        </div>
        <div className="carrier-data-form carrier-data-form__right">
          <p className="mt-0 mr-0 color-blue-3 text-bold font-size-24">
            Διεύθυνση Έδρας Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_2.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={viewMode}
                      {...omit(field, ['span', 'rules'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default CompanyDetails;
